import React from "react";
import clsx from "clsx";

import { checkSurfaceType, ISurfaceData } from "../../helper";
import useStyles from "../../styles";

interface IProps {
  additionalClassName?: string;
  surfaceData: ISurfaceData;
}

const cellNumbersWithDashedBorder = new Set([1, 3, 7]);

const SurfaceRowContent = (props: IProps) => {
  const {
    surfaceData: { data, type },
    additionalClassName
  } = props;
  const classes = useStyles();
  const { isDirt, isTurfAndSynthetic } = checkSurfaceType(type);

  const renderCells = () => {
    const cells = Object.keys(data);

    return cells.map((key, index) => {
      const hasDashedBorder = cellNumbersWithDashedBorder.has(index);

      return (
        <div
          key={key + index}
          className={clsx(classes.cell, additionalClassName, {
            [classes.dirtDashedBorder]: hasDashedBorder && isDirt,
            [classes.turfAndSyntheticDashedBorder]:
              hasDashedBorder && isTurfAndSynthetic
          })}
        >
          {data[key]}
        </div>
      );
    });
  };

  return <>{renderCells()}</>;
};

export default SurfaceRowContent;
